"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaletteShades = void 0;
const tinycolor2_1 = __importDefault(require("tinycolor2"));
const shallowCompare_1 = __importDefault(require("../../shared/shallowCompare"));
const getColorShades_1 = __importDefault(require("./getColorShades"));
const cache = [];
const getPaletteShades = (shadeBases) => {
    const isEqualToBase = (0, shallowCompare_1.default)(shadeBases);
    const inCache = cache.find((record) => isEqualToBase(record.bases));
    if (inCache) {
        return inCache.value;
    }
    const newValue = {
        primary: (0, getColorShades_1.default)(shadeBases.primary),
        secondary: (0, getColorShades_1.default)(shadeBases.secondary),
        black: (0, getColorShades_1.default)(shadeBases.black),
    };
    cache.push({
        bases: shadeBases,
        value: newValue,
    });
    return newValue;
};
exports.getPaletteShades = getPaletteShades;
const getColorFromSpecificationBuilder = (paletteShades) => (specification) => {
    if (specification && specification.type === 'palette') {
        const { value: { base, shade, alpha } } = specification;
        const hexColor = paletteShades[base][shade].value;
        if (alpha === null || alpha === undefined) {
            return hexColor;
        }
        const rgbColor = (0, tinycolor2_1.default)(hexColor).clone();
        return rgbColor.setAlpha(alpha).toString();
    }
    if (specification && specification.type === 'custom') {
        return specification === null || specification === void 0 ? void 0 : specification.value;
    }
    return undefined;
};
exports.default = getColorFromSpecificationBuilder;
